<div class="share-overlay">

  <div class="share-overlay__items-grid">
    <a [href]="'mailto:?subject=' + subject +'&body=' + text + url" class="share-overlay__item">
      <div class="share-overlay__item-icon"><brt-icon [icon]="'social-email'"></brt-icon></div>
      <div class="share-overlay__item-title">E-Mail</div>
    </a>
    <a [href]="'https://wa.me/?text=' + text + url" class="share-overlay__item" target="_blank">
      <div class="share-overlay__item-icon"><img [src]="'/assets/img/icons/SUBEJCT=Share-WhatsApp.svg'" alt="WhatsApp" /></div>
      <div class="share-overlay__item-title">Whatsapp</div>
    </a>
    <a [href]="'tg://msg_url?url=' + url + '&text=' + text" class="share-overlay__item" target="_blank">
      <div class="share-overlay__item-icon"><img [src]="'/assets/img/icons/SUBEJCT=Share-Telegram.svg'" alt="Telegram" /></div>
      <div class="share-overlay__item-title">Telegram</div>
    </a>
    <a [href]="'http://m.me/berufsreise?text=' + text" class="share-overlay__item" target="_blank">
      <div class="share-overlay__item-icon"><img [src]="'/assets/img/icons/SUBEJCT=Share-Messenger.svg'" alt="Messenger" /></div>
      <div class="share-overlay__item-title">Messenger</div>
    </a>
    <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + url +'&title='+ subject + '&quote=' + subject" target="_blank" class="share-overlay__item">
      <div class="share-overlay__item-icon"><img [src]="'/assets/img/icons/SUBEJCT=Share-Facebook.svg'" alt="Facebook" /></div>
      <div class="share-overlay__item-title">Facebook</div>
    </a>
    <a [href]="'https://twitter.com/intent/tweet?text=' + text + url" target="_blank" class="share-overlay__item">
      <div class="share-overlay__item-icon"><img [src]="'/assets/img/Share-X.svg'" alt="Instagram" /></div>
      <div class="share-overlay__item-title">X</div>
    </a>
  </div>

  <div class="share-overlay__copy-line">
    <div class="share-overlay__copy-link">{{url}}</div>
    <div class="share-overlay__copy-button" [ngClass]="{'copied': isLinkCopied}" (click)="copyShareLinkToClipboard()">
      <ng-container *ngIf="isLinkCopied; else notCopied;">
        <brt-button [title]="'Link Kopiert'" [before-icon]="'check-circle'" [size]="'small'" [color]="'white'"></brt-button>
      </ng-container>
      <ng-template #notCopied>
        <brt-button [title]="'Kopieren'" [size]="'small'" [color]="'red'"></brt-button>
      </ng-template>
    </div>
  </div>

</div>
